
















































import { Component, Watch, Vue } from 'vue-property-decorator';
import posed, { PoseTransition } from 'vue-pose';

import { IWidgetSettingsFormData } from '@/models/Widget/settings';

import WidgetConfigForm from '@/componentsV2/organisms/WidgetConfigFormV2/WidgetConfigFormV2.vue';

import MerchantService from '@/api/MerchantService';

import {
  baseAnimations,
  transformWidgetPayload
} from '@/views/Onboarding/helpers';
import { validation as validateWidgetConfig } from '@/views/Onboarding/Steps/LoyaltyWidget/validation';
import { FilledButton } from '@/components/molecules';
import { BusinessOnboardingState } from '@/models/business-onboarding';
import { updateRegistration } from '@/utils/updateRegistration';
import { ERewardsProgramStepSlug } from '@/componentsV2/templates/Modals/RewardsProgramModal/RewardsProgramModal.vue';
import { RewardsProgramFormState } from '@/models/rewards-program';
import flagKeys from '@/constants/flagKeys';
import { OnlineOnboardingURL } from '@/views/Onboarding/helpers';
import eventBus from '@/utils/eventBus';
import BusinessService from '@/api/BusinessService';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import LoyaltyWidgetConfigIlustra from './LoyaltyWidgetConfigIlustra.vue';
import { scrollToTop } from '@/utils/scrollToTop';

@Component({
  components: {
    PoseTransition,
    Container: posed.div(baseAnimations()),
    WidgetConfigForm,
    FilledButton,
    Typography,
    LoyaltyWidgetConfigIlustra
  }
})
export default class LoyaltyWidgetConfig extends Vue {
  merchantService = new MerchantService();
  businessService: BusinessService = new BusinessService();

  loading = false;

  OnlineOnboardingURL = OnlineOnboardingURL;

  get currentProvider() {
    return this.$store.getters[
      'merchant/getConnectedProviderWithWidgetSettings'
    ];
  }

  get description() {
    return `Your widget is the small interactive window on your website that allows members to engage with your Rewards Program.`;
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get businessOnboardingState(): BusinessOnboardingState {
    return this.$store.getters[
      'businessOnboarding/getBusinessOnboardingState'
    ] as BusinessOnboardingState;
  }

  get rewardsProgramFormData() {
    return this.$store.getters[
      'rewardsProgram/getFormData'
    ] as RewardsProgramFormState;
  }

  get formData() {
    return this.$store.getters[
      'businessOnboarding/getLoyaltyWidgetForm'
    ] as IWidgetSettingsFormData;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  @Watch('formData', { deep: true })
  emitFormDataProps() {
    this.handleChangeWidgetConfig({
      ...this.formData
    });
    this.validate();
  }

  validate() {
    return validateWidgetConfig(this.formData, true);
  }

  handleChangeWidgetConfig(formData: IWidgetSettingsFormData) {
    this.$store.dispatch(
      'businessOnboarding/SET_LOYALTY_WIDGET_FORM',
      formData
    );
  }

  updateWidgetProviderSettings() {
    const widgetSettings = transformWidgetPayload(this.formData);

    this.$store.dispatch(
      'merchant/UPDATE_WIDGET_PROVIDER_SETTINGS',
      widgetSettings
    );

    return this.merchantService.setConnectSettings(
      this.currentProvider.oauthId,
      widgetSettings
    );
  }

  async onSubmit() {
    if (!this.validate()) return;

    this.loading = true;

    const response = await this.updateWidgetProviderSettings();

    if (response.status === 200) {
      this.$store.dispatch(
        'merchant/UPDATE_WIDGET_PROVIDER_SETTINGS',
        this.formData
      );
      await updateRegistration('widget-setup');

      if (this.flags.includes(flagKeys.billingModuleV4)) {
        this.$router.push(OnlineOnboardingURL.LOYALTY_FEEDBACK_STATUS);
      } else {
        this.$router.push({
          path: '/home',
          query: {
            modal: 'rewardsProgramModal',
            showStartGuideHighlight: 'true',
            initialStep: ERewardsProgramStepSlug.FEEDBACK_STATUS
          }
        });
      }
    }
    this.loading = false;
  }

  async created() {
    scrollToTop('bo-base-layout__right');

    if (!this.businessInfo) {
      this.businessService.getBusinessInfo().then((res: any) => {
        eventBus.$emit('setBusinessInfo', res.data);
        const data = res.data;
        data.manager = data.loggedInManager;
        this.$store.dispatch('business/SET_BUSINESS_INFO', {
          ...this.$store.getters['business/getBusinessState'],
          ...data
        });
      });
    }
  }
}
